import { apiFetch } from 'requests/requests';

const DOMAIN = process.env.REACT_APP_API_URL;

/**
 * Custom baseQuery for RTK Query that wraps the existing apiFetch.
 * Preserves auth token injection, 401 refresh/retry, and error handling.
 */
const rcBaseQuery = async ({ url, method = 'GET', body, params }) => {
    try {
        let fullUrl = `${DOMAIN}${url}`;
        if (params) {
            const sp = new URLSearchParams();
            Object.entries(params).forEach(([k, v]) => {
                if (v !== undefined && v !== null) sp.append(k, v);
            });
            const qs = sp.toString();
            if (qs) fullUrl += `?${qs}`;
        }
        const result = await apiFetch({
            url: fullUrl,
            method,
            body: body ? JSON.stringify(body) : undefined
        });
        return { data: result };
    } catch (error) {
        return {
            error: {
                status: 'CUSTOM_ERROR',
                error: error.message,
                type: error.type,
                data: error.data
            }
        };
    }
};

export default rcBaseQuery;
